import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import ReadOnlyData from '../ReadOnlyData';
import {FIRE_RISK, MACHINERY_DIFFICULTY} from '../../../../../config';
import {getLabelById} from '../../../../../utils/getLabelById';

const MonitoringMassDescription = ({id_rodal, area, species_label, centroid, fire_risk, machinery_difficulty, initialPlantingYear}) => {

  const currentYear = new Date().getFullYear()-1;

  return <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'space-around', mt: 1}}>
    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
      <ReadOnlyData label='ID Rodal' value={id_rodal}/>
      <ReadOnlyData label='Especie' value={species_label.toUpperCase()}/>
      <ReadOnlyData label='Edad' value={currentYear-initialPlantingYear}/>
    </Box>
    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', ml: 12}}>
      <ReadOnlyData label='Superficie' value={area}/>
      <ReadOnlyData label='Coordenadas del centroide (x, y)' value={`${centroid[0]}, ${centroid[1]}`}/>
    </Box>
    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', ml: 12}}>
      <ReadOnlyData label='Zona riesgo incendio' value={getLabelById(fire_risk, FIRE_RISK) || '-'}/>
      <ReadOnlyData label='Dificultad mecanizado' value={getLabelById(machinery_difficulty, MACHINERY_DIFFICULTY) || '-'}/>
    </Box>
  </Box>;
};

MonitoringMassDescription.propTypes = {
  id_rodal: PropTypes.number.isRequired,
  area: PropTypes.number.isRequired,
  species_label: PropTypes.string.isRequired,
  centroid: PropTypes.arrayOf(PropTypes.number).isRequired,
  fire_risk: PropTypes.string.isRequired,
  machinery_difficulty: PropTypes.string.isRequired,
  initialPlantingYear: PropTypes.number.isRequired,
};

export default MonitoringMassDescription;